import { Component, OnInit } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";
@Component({
  selector: 'emi-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class partnersComponent implements OnInit {
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/partners/partners.component.ts